import React from 'react';
import styled from 'styled-components';

const Hero = styled.section<{ backgroundImage: string; compact?: boolean }>`
  height: ${(props) => (props.compact ? '50vh' : '100vh')};
  background-image: linear-gradient(116.47deg, rgba(26, 49, 86, 0.63) 0%, rgba(41, 78, 137, 0.56) 78.08%),
    url(${(props) => props.backgroundImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: ${(props) => (props.compact ? '40vh' : '80vh')};
  }
`;

const Title = styled.h1`
  color: white;
  font-size: 48px;
  font-weight: 700;
  margin: 0 auto;
  max-width: 1200px;
  margin-bottom: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;

const Subtitle = styled.p`
  color: white;
  font-size: 24px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 1200px;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1rem;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 0 1rem;
  }
`;

const Button = styled.a<{ primary?: boolean }>`
  padding: 14px 25px;
  border-radius: 5px;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 160px;
  text-align: center;

  ${(props) =>
    props.primary
      ? `
    background-color: #2B3B5C;
    color: white;
  `
      : `
    background-color: white;
    color: #2B3B5C;
  `}

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 12px 12px;
    text-align: center;
    min-width: 120px;
  }
`;

interface HeroComponentProps {
  backgroundImage: string;
  title: string;
  subtitle?: string;
  primaryButton?: ButtonProps;
  secondaryButton?: ButtonProps;
  compact?: boolean;
}

interface ButtonProps {
  text: string;
  link: string;
}

const HeroComponent: React.FC<HeroComponentProps> = ({
  backgroundImage,
  title,
  subtitle,
  primaryButton,
  secondaryButton,
  compact = false,
}) => {
  return (
    <Hero backgroundImage={backgroundImage} compact={compact}>
      <Title dangerouslySetInnerHTML={{ __html: title }} />
      {subtitle && <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />}
      <ButtonContainer>
        {secondaryButton && <Button href={secondaryButton.link}>{secondaryButton.text}</Button>}
        {primaryButton && (
          <Button href={primaryButton.link} primary>
            {primaryButton.text}
          </Button>
        )}
      </ButtonContainer>
    </Hero>
  );
};

export default HeroComponent;
